// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Hyrl0","slideUp":"styles_slideUp__asZfA"};